import React from "react";
import { Logo } from "@/components/Logo";
import { TAGLINE } from "@/lib/branding";

// TAMPILAN-SOQ tahap 3: the shared header of the customer pages (tracking,
// digital nota, customer page, ACC): royal blue band, orange slanted stripes,
// logo, title in the jersey lettering, tagline. `mesin` = the machine line
// drawing (owner: only login and tracking). On paper (print / save as PDF) the
// band is replaced by a plain dark-on-white header, because browsers drop
// background colours when printing and white text would vanish.
export default function PublicHeader({ judul, sub = null, mesin = false, namaUsaha = null, testid = "public-header" }) {
  return (
    <>
      <header data-testid={testid} className="print:hidden relative overflow-hidden bg-soq-biru text-white px-4 pt-7 pb-16 [clip-path:polygon(0_0,100%_0,100%_86%,0_100%)]">
        {mesin && <div className="latar-mesin absolute inset-0 pointer-events-none" aria-hidden />}
        <span aria-hidden className="absolute top-0 bottom-0 -right-6 w-16 sm:w-24 bg-soq-oranye [transform:skewX(-14deg)]" />
        <span aria-hidden className="absolute top-0 bottom-0 right-16 sm:right-28 w-3 sm:w-4 bg-soq-oranye [transform:skewX(-14deg)]" />
        <div className="relative mx-auto w-full max-w-2xl pr-20 sm:pr-32">
          <Logo varian="putih" className="h-9 w-auto" />
          <h1 className="mt-3 font-judul text-[34px] leading-none uppercase !text-white">{judul}</h1>
          {sub && <p className="mt-2 text-[15px] font-semibold text-white">{sub}</p>}
          <p className="mt-1 text-sm text-[#DDE1FF]">{namaUsaha ? `${namaUsaha} · ` : ""}{TAGLINE}</p>
        </div>
      </header>
      <div className="hidden print:block text-center border-b border-slate-300 pb-3 mb-3">
        <Logo varian="hitam" className="mx-auto mb-1 h-10 w-auto" />
        {namaUsaha && <div className="text-xl font-bold">{namaUsaha}</div>}
        <div className="text-sm">{judul}{sub ? ` · ${sub}` : ""}</div>
      </div>
    </>
  );
}
